import { defineMessages } from 'react-intl';

const messages = defineMessages({
  // T11 fix round 1 — split off `finance` (renamed to "Billing &
  // Subscriptions" and moved to the account menu, `SettingsDropdown/
  // messages.ts`): this platform-admin-only row is a DIFFERENT page
  // (`/admin/finance`, `AdminFinancePage.tsx`, cross-tenant platform
  // finance, not a billing surface — a platform user is never a payer,
  // P2 in root CLAUDE.md) and must not carry the billing label.
  adminFinance: {
    id: 'features.sidebar.adminFinance',
    defaultMessage: 'Platform finance',
  },
  adminUsers: {
    id: 'features.sidebar.adminUsers',
    defaultMessage: 'Admin Users',
  },
  analytics: {
    id: 'features.sidebar.analytics',
    defaultMessage: 'Analytics',
  },
  appBranding: {
    id: 'features.sidebar.appBranding',
    defaultMessage: 'App Branding',
  },
  bookingEventTemplates: {
    id: 'features.sidebar.bookingEventTemplates',
    defaultMessage: 'Booking templates',
  },
  bookingStats: {
    id: 'features.sidebar.bookingStats',
    defaultMessage: 'Session statistics',
  },
  categories: {
    id: 'features.sidebar.categories',
    defaultMessage: 'Categories',
  },
  clients: {
    id: 'features.sidebar.clients',
    defaultMessage: 'Clients',
  },
  configurables: {
    id: 'features.sidebar.configurables',
    defaultMessage: 'Configurables',
  },
  corpOrganizations: {
    id: 'features.sidebar.corpOrganizations',
    defaultMessage: 'Corporate organizations',
  },
  currentOrganization: {
    id: 'features.sidebar.currentOrganization',
    defaultMessage: 'Organization management',
  },
  dashboard: {
    id: 'features.sidebar.dashboard',
    defaultMessage: 'Dashboard',
  },
  education: {
    id: 'features.sidebar.education',
    defaultMessage: 'Education',
  },
  exercises: {
    id: 'features.sidebar.exercises',
    defaultMessage: 'Exercises',
  },
  home: {
    id: 'features.sidebar.home',
    defaultMessage: 'Home',
  },
  // Top-of-menu cross-org overview, shown once the account is in 2+
  // organizations; each organization keeps its own `orgHome` row.
  myHome: {
    id: 'features.sidebar.myHome',
    defaultMessage: 'My Home',
  },
  library: {
    id: 'features.sidebar.library',
    defaultMessage: 'Library',
  },
  tenantAdmin: {
    id: 'features.sidebar.tenantAdmin',
    defaultMessage: 'Tenant admin',
  },
  platform: {
    id: 'features.sidebar.platform',
    defaultMessage: 'Platform',
  },
  marketplace: {
    id: 'features.sidebar.marketplace',
    defaultMessage: 'Marketplace',
  },
  memberships: {
    id: 'features.sidebar.memberships',
    defaultMessage: 'Memberships',
  },
  myProfile: {
    id: 'features.sidebar.myProfile',
    defaultMessage: 'My Profile',
  },
  notificationCenter: {
    id: 'features.sidebar.notificationCenter',
    defaultMessage: 'Notification Center',
  },
  nutrition: {
    id: 'features.sidebar.nutrition',
    defaultMessage: 'Nutrition',
  },
  organizationProfile: {
    id: 'features.sidebar.organizationProfile',
    defaultMessage: 'Organization Profile',
  },
  organizations: {
    id: 'features.sidebar.organizations',
    defaultMessage: 'Organizations',
  },
  // T15 — "Payouts" moved out of the billing page's tab strip into its own
  // sidebar row (`sidebar-payouts`), reusing the Serbian text already
  // translated for `financePages.payouts.tab`.
  payouts: {
    id: 'features.sidebar.payouts',
    defaultMessage: 'Payouts',
  },
  personalTrainers: {
    id: 'features.sidebar.personalTrainers',
    defaultMessage: 'Personal Trainers',
  },
  premium: {
    id: 'features.sidebar.premium',
    defaultMessage: 'Premium',
  },
  tenantAppBranding: {
    id: 'features.sidebar.tenantAppBranding',
    defaultMessage: 'Tenant App Branding',
  },
  privacyPolicies: {
    id: 'features.sidebar.privacyPolicies',
    defaultMessage: 'Privacy Policies',
  },
  marketplaceAccess: {
    id: 'features.sidebar.marketplaceAccess',
    defaultMessage: 'Marketplace access',
  },
  publicPages: {
    id: 'features.sidebar.publicPages',
    defaultMessage: 'Public Pages',
  },
  programs: {
    id: 'features.sidebar.programs',
    defaultMessage: 'Programs',
  },
  questionnaires: {
    id: 'features.sidebar.questionnaires',
    defaultMessage: 'Questionnaires',
  },
  rolesAndPermissions: {
    id: 'features.sidebar.rolesAndPermissions',
    defaultMessage: 'Roles and Permissions',
  },
  saved: {
    id: 'features.sidebar.saved',
    defaultMessage: 'Saved',
  },
  schedule: {
    id: 'features.sidebar.schedule',
    defaultMessage: 'Schedule',
  },
  // F4.3 — distinct from `schedule` above (existing "view my own profile at
  // this org" nav item, left untouched) — these are the new Org Home/Org
  // Schedule pages from Phase 2/3.
  orgHome: {
    id: 'features.sidebar.orgHome',
    defaultMessage: 'Home',
  },
  orgSchedule: {
    id: 'features.sidebar.orgSchedule',
    defaultMessage: 'Schedule',
  },
  // T1 — kept distinct from `orgSchedule` below: in an organization context
  // both entries are visible at once, and two rows reading "My calendar" and
  // "<Org> Schedule" do not say which one holds the personal profile's
  // events.
  myCalendar: {
    id: 'features.sidebar.myCalendar',
    defaultMessage: 'My calendar',
  },
  staff: {
    id: 'features.sidebar.staff',
    defaultMessage: 'Reception',
  },
  stats: {
    id: 'features.sidebar.stats',
    defaultMessage: 'Statistics',
  },
  tenants: {
    id: 'features.sidebar.tenants',
    defaultMessage: 'Tenants',
  },
  trainerProfile: {
    id: 'features.sidebar.trainerProfile',
    defaultMessage: 'Trainer Profile',
  },
  trainers: {
    id: 'features.sidebar.trainers',
    defaultMessage: 'Trainers',
  },
  users: {
    id: 'features.sidebar.users',
    defaultMessage: 'Users',
  },
  workouts: {
    id: 'features.sidebar.workouts',
    defaultMessage: 'Workouts',
  },
  // Sectioned-sidebar IA — `stats` stays as-is (still used verbatim by the
  // untouched Super Admin block), so the account-level and org-level stats
  // items each get their own distinct label below.
  statistics: {
    id: 'features.sidebar.statistics',
    defaultMessage: 'Statistics',
  },
  workoutContent: {
    id: 'features.sidebar.workoutContent',
    defaultMessage: 'Workout Content',
  },
  tutorials: {
    id: 'features.sidebar.tutorials',
    defaultMessage: 'Tutorials',
  },
  bundles: {
    id: 'features.sidebar.bundles',
    defaultMessage: 'Bundles',
  },
  businessPerformance: {
    id: 'features.sidebar.businessPerformance',
    defaultMessage: 'Business Performance',
  },
  profitsAndLosses: {
    id: 'features.sidebar.profitsAndLosses',
    defaultMessage: 'Profits & Losses',
  },
  desk: {
    id: 'features.sidebar.desk',
    defaultMessage: 'Desk',
  },
  lockerKeys: {
    id: 'features.sidebar.lockerKeys',
    defaultMessage: 'Keys',
  },
  workPerformance: {
    id: 'features.sidebar.workPerformance',
    defaultMessage: 'Work Performance',
  },
  finances: {
    id: 'features.sidebar.finances',
    defaultMessage: 'Finances',
  },
  crm: {
    id: 'features.sidebar.crm',
    defaultMessage: 'CRM',
  },
  businessAndFinance: {
    id: 'features.sidebar.businessAndFinance',
    defaultMessage: 'Business & Finance',
  },
  profileSection: {
    id: 'features.sidebar.profileSection',
    defaultMessage: 'Management',
  },
  soon: {
    id: 'features.sidebar.soon',
    defaultMessage: 'Soon',
  },
});

export default messages;
